import { openConsultationMail } from "../config/contact";
import React from "react";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet-async";
import { FiArrowUpRight, FiCheck, FiPlus } from "react-icons/fi";
import { Link } from "react-router-dom";
import whyImg1 from "../assets/Choose-bro.png";
import whyImg2 from "../assets/Starting a business project-amico.png";
import cardImg1 from "../assets/SEO analytics team-amico.png";
import cardImg2 from "../assets/Conversion rate optimization-amico (1).png";
import cardImg3 from "../assets/Social media-amico.png";
import cardImg4 from "../assets/Windows-amico.png";
import cardImg5 from "../assets/Marketing consulting-amico.png";
import cardImg6 from "../assets/Mobile Marketing-amico.png";
import cardImg7 from "../assets/SEO analytics team-cuate.png";
import cardImg8 from "../assets/Consultative sales-amico.png";













const SERVICES = [
  {
    title: "Search Engine Optimization (SEO)",
    text: "Improve your website’s rankings and attract the right audience with strategies focused on long-term organic growth.",
    img: cardImg1,
    path: "/seo-services-delhi-ncr",
  },
  {
    title: "Pay-Per-Click (PPC) Advertising",
    text: "Drive instant traffic and generate quality leads through targeted ad campaigns optimized for better performance.",
    img: cardImg2,
    path: "/ppc-services-delhi-ncr",
  },
  {
    title: "Social Media Marketing",
    text: "Build a strong brand presence and connect with your audience through consistent and engaging content.",
    img: cardImg3,
    path: "/social-media-marketing-delhi-ncr",
  },
  {
    title: "Website Design & Development",
    text: "Create a responsive and user-friendly website designed to deliver a smooth experience and better conversions.",
    img: cardImg4,
    path: "/website-design-development-delhi-ncr",
  },
  {
    title: "Content Marketing",
    text: "Develop valuable and SEO-friendly content that builds trust and supports your overall marketing strategy.",
    img: cardImg5,
    path: "/content-marketing-services-delhi-ncr",
  },
  {
    title: "Email Marketing",
    text: "Engage your audience with personalized email campaigns that nurture leads and improve conversions.",
    img: cardImg6,
    path: "/email-marketing-services-delhi-ncr",
  },
  {
    title: "On-Page SEO Optimization",
    text: "Optimize your website’s content, structure, and key elements to improve rankings and user experience.",
    img: cardImg7,
    path: "/seo-services-delhi-ncr",
  },
  {
    title: "Ecommerce Marketing",
    text: "Grow your online store with strategies focused on improving visibility, increasing traffic, and driving more sales.",
    img: cardImg8,
    path: "/ecommerce-services-delhi-ncr",
  },
];

const WHY_POINTS = [
  {
    title: "Result-Focused Approach",
    text: "We focus on improving rankings, traffic, and lead generation.",
  },
  {
    title: "Customized Strategies",
    text: "Every plan is tailored to your business goals and target audience.",
  },
  {
    title: "Transparent Process",
    text: "We keep communication clear with regular updates and insights.",
  },
  {
    title: "Long-Term Growth",
    text: "Our strategies are designed for sustainable business growth.",
  },
];

const scrollReveal = {
  initial: { opacity: 0, y: 28 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.18 },
  transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] },
};

const heroLine = {
  initial: { opacity: 0, y: 18 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.9 },
  transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1] },
};

const containerStagger = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.06, delayChildren: 0.05 },
  },
};

const itemFade = {
  hidden: { opacity: 0, y: 18 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1] } },
};

function ServicePageNew() {
  const scrollToContact = openConsultationMail; // replaced

  return (
    <>
      <Helmet>
        <title>Digital Marketing Services Company in India | SEO, PPC & More</title>
        <meta name="description" content="Explore our digital marketing services including SEO, PPC, social media, and performance marketing. Grow your business with expert strategies." />
      </Helmet>
      <main className="service-page">
      {/* Hero */}
      <section className="about-page-hero" aria-label="Services hero">
        <div className="about-page-hero-inner">
          <motion.h1 {...heroLine} transition={{ duration: 0.5, delay: 0.02 }}>
            Digital Marketing Services
          </motion.h1>
          <motion.p
            className="service-hero-sub"
            {...heroLine}
            transition={{ duration: 0.5, delay: 0.1 }}
          >
            Result-driven strategies to improve your online visibility, traffic, and leads.
          </motion.p>
          <motion.p
            className="service-hero-breadcrumb"
            {...heroLine}
            transition={{ duration: 0.5, delay: 0.18 }}
          >
            Home &nbsp;&gt;&nbsp; Services
          </motion.p>
        </div>
      </section>

      {/* Services Cards */}

      <motion.section className="service-cards-section" {...scrollReveal}>
        <div className="service-cards-inner">
          <motion.div
            className="service-cards-grid"
            variants={containerStagger}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.12 }}
          >
            {SERVICES.map((s) => (
              <motion.article key={s.title} className="service-card" variants={itemFade}>
                <Link to={s.path} className="service-card-link">
                  <div className="service-card-image-wrap">
                    <img src={s.img} alt={s.title} />
                  </div>
                  <h3>{s.title}</h3>
                  <p>{s.text}</p>
                  <span className="service-card-arrow"><FiArrowUpRight /></span>
                </Link>
              </motion.article>
            ))}
          </motion.div>
        </div>
      </motion.section>

      {/* Why Choose Us */}
      <motion.section
        className="service-why-section"
        aria-labelledby="service-why-heading"
        {...scrollReveal}
      >
        <div className="service-why-bg" aria-hidden />
        <div className="service-why-inner">
          <motion.header
            className="service-why-header"
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.55 }}
          >
            <h2 id="service-why-heading">Why Choose Our Digital Marketing Services</h2>
          </motion.header>

          <div className="service-why-columns">
            <motion.div
              className="service-why-copy"
              initial={{ opacity: 0, x: -24 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.25 }}
              transition={{ duration: 0.6 }}
            >
              <p className="service-why-intro">
                We don’t believe in random marketing. Every strategy is built around your business, your
                audience, and what actually drives results.
              </p>
              <ul className="service-why-list">
                {WHY_POINTS.map((row) => (
                  <li key={row.title}>
                    <span className="service-why-check" aria-hidden>
                      <FiCheck />
                    </span>
                    <div>
                      <strong>{row.title}</strong>
                      <span>{row.text}</span>
                    </div>
                  </li>
                ))}
              </ul>
            </motion.div>

            <motion.div
              className="service-why-visual"
              initial={{ opacity: 0, x: 24 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.25 }}
              transition={{ duration: 0.6, delay: 0.05 }}
            >
              <span className="service-why-plus" aria-hidden>
                <FiPlus />
              </span>
              <span className="service-why-star" aria-hidden>
                ✷
              </span>
              <div className="service-why-pills">
                <div className="service-why-pill service-why-pill--lower">
                  <img src={whyImg1} alt="Strategy session" />
                </div>
                <div className="service-why-pill service-why-pill--higher">
                  <img src={whyImg2} alt="Marketing professional" />
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </motion.section>

      {/* CTA */}
      <motion.section className="service-page-cta" aria-labelledby="service-cta-heading" {...scrollReveal}>
        <motion.div
          className="service-page-cta-inner"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.35 }}
          transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
        >
          <span className="service-page-cta-ripple service-page-cta-ripple--left" aria-hidden />
          <span className="service-page-cta-ripple service-page-cta-ripple--right" aria-hidden />
          <h2 id="service-cta-heading">Let’s Build a Strategy That Works for You</h2>
          <p>
            From SEO to paid campaigns and ecommerce growth, we help you drive traffic, generate leads,
            and grow your business online.
          </p>
          <button type="button" className="service-page-cta-btn" onClick={scrollToContact}>
            Get Free Consultation
            <span className="our-values-learn-icon">
              <FiArrowUpRight />
            </span>
          </button>
        </motion.div>
      </motion.section>
      </main>
    </>
  );
}

export default ServicePageNew;

